import { Component, Prop, Vue } from 'vue-property-decorator';
import { CuentaBancaria } from '@conacyt/historicopersonasms-client';
import * as dateUtils from '@/shared/date/date-utils';
import * as formatterUtils from '@/shared/formatter/formatter-utils';
import HistoryItemComponent from '@/components/expediente-persona/history-item/history-item.vue';
import { EstadoSolicitud } from '@conacyt/perfil-usuario-client';

interface CuentaBancariaExt extends CuentaBancaria {
  activo?: boolean;
}

@Component({
  components: {
    'history-item': HistoryItemComponent,
  },
})
export default class CuentasBancariasComponent extends Vue {
  @Prop({ required: false })
  public item: Array<CuentaBancariaExt>;

  get cuentasBancarias(): Array<CuentaBancariaExt> {
    return this.item;
  }

  mounted() {
    this.mostrarCuentaBancariaActiva();
  }

  get fields() {
    return [
      { key: 'activo', label: 'Activo', sortable: true },
      { key: 'proceso', label: 'Proceso', sortable: true },
      { key: 'banco', label: 'Banco', sortable: true },
      { key: 'numeroCuenta', label: 'Cuenta clabe', sortable: true },
      { key: 'estadoSolicitud', label: 'Estado', sortable: true },
      {
        key: 'fechaModificacion',
        label: 'Fecha modificación',
        sortable: true,
        formatter: value => dateUtils.formatUtc(value),
      },
      {
        key: 'urlComprobante',
        label: 'URL comprobante',
        sortable: true,
        linkComprobante: true,
      },
    ];
  }

  private mostrarCuentaBancariaActiva() {
    this.cuentasBancarias?.forEach(ayudantia => {
      if (ayudantia.estadoSolicitud === EstadoSolicitud.ENVIADA) {
        ayudantia.activo = true;
      } else {
        ayudantia.activo = false;
      }
    });
  }
}
